import { Colors } from '@zapier/design-system';
import { css } from '@emotion/core';

const Styles = {
  clickableRow: css`
    cursor: pointer;
    &:hover {
      background-color: none;
    }
    overflow-wrap: anywhere;
  `,
  clickableCell: css`
    text-align: left;
  `,
  cell: css`
    display: table-cell;
    vertical-align: middle;
    text-align: initial;
  `,
  rowDetails: css`
    padding: 10px;
  `,
  details: css`
    padding: 15px;
  `,
  code: css`
    white-space: pre-wrap;
    color: ${Colors.Red4};
    word-break: break-all;
    word-wrap: break-word;
    line-height: 20px;
    width: 80%;
  `,
  preWrap: css`
    white-space: pre-wrap;
  `,
};

export default Styles;
